<template>
  <div class="main">
    <dd-header></dd-header>
    <template v-if="!isConfirm">
      <div class="title">
        <img :src="getImage('sketchorder_banner_01.gif')" alt="SKETCH ORDER">
      </div>
      <article class="overview">
        <section id="about">
          <div class="frame_by_frame" id="about_list">
            <h2><p class="new_order">NEW!</p>新しいオーダー家具の買い方！</h2>
            <img :src="getImage('sketchorder_banner_02.gif')" alt="スケッチオーダーとは" @click="onSketchUpload">
            <p data-nosnippet>
              あなたの理想のイメージをスケッチしてアップロードすれば、オーダー家具の専門家が図面と見積書を作成して貴方だけの収納をご提案をします！
            </p>
            <!-- <ul class="img_container">
              <li><img class="img_list" :src="getImage('about_sketch_order/sketchorder_banner_01.webp')" alt="スケッチオーダーとは1"></li>
              <li><img class="img_list" :src="getImage('about_sketch_order/sketchorder_banner_02.webp')" alt="スケッチオーダーとは2"></li>
              <li><img class="img_list" :src="getImage('about_sketch_order/sketchorder_banner_03.webp')" alt="スケッチオーダーとは3"></li>
            </ul> -->
            <!-- <img class="img_list" :src="getImage('about_sketch_order/sketchorder_header.webp')" alt="スケッチオーダーとは1"> -->
            <!-- <dd-banner
              ref="ddBannerListRef"
              :swipeList="bannerList"
              :swiperOptions="categoryOptions"
              :horizontalMode="false"
              v-else
            /> -->
            <!-- <a class="btn_prev" href="javascript:void(0); return false;"><img :src="getImage('btn_prev.png')" alt="preview"></a>
            <a class="btn_next" href="javascript:void(0); return false;"><img :src="getImage('btn_next.png')" alt="next"></a> -->
          </div>
        </section>
        <section id="plan_list">
          <h3 data-nosnippet>自分が考えた、壁から壁までピッタリの収納！</h3>
          <div class="case_study_plan">
            <picture>
              <!-- <source :srcset="getImage('paln_photo/photo_all_sp.png')" type="image/png" media="(min-width: 520px)"> -->
              <source :srcset="getImage('paln_photo/photo_all.png')" type="image/png" media="(min-width: 960px)">
              <img :src="getImage('paln_photo/photo_all_sp.png')" type="image/png" alt="事例＆デザインプラン">
            </picture>
            <!-- <ul class="img_container">
              <li><img class="img_list" :src="getImage('paln_photo/001.jpg')" alt="事例＆デザインプラン"></li>
              <li><img class="img_list" :src="getImage('paln_photo/002.jpg')" alt="事例＆デザインプラン"></li>
              <li><img class="img_list" :src="getImage('paln_photo/003.jpg')" alt="事例＆デザインプラン"></li>
            </ul> -->
            <!-- <a class="btn_prev" href="javascript:void(0); return false;"><img :src="getImage('btn_prev.png')" alt="preview"></a>
            <a class="btn_next" href="javascript:void(0); return false;"><img :src="getImage('btn_next.png')" alt="next"></a> -->
          </div>
        </section>
        <section id="service">
          <h3>私たちの「スケッチオーダー」サービスについて</h3>
          <p class="description">
            私たちは住宅設備（キッチン・収納・建具など）の設計製造データを自動生成するクラウドシステムの開発会社であるドゥーマンズと、製造技術による量的背景と品質に特化した大手木工工場と、匠の技と地域密着型の施工技術に特化した職人集団である東京建具協同組合が提携して立ち上げたジョイントベンチャーです。<br>
            これまでの各社の技術やノウハウを活かし、最高品質のオーダー家具の製造から設置施工まで全国で対応し、最高の住み心地を提供することを目指しています。<br>
            この提携により、量的背景を利用したスピードと価格と品質を、また量的背景の真逆である一品造りの匠の技と職人施工技術、そして本来すべてが人工作業である設計図の作成や見積積算及び製造データ作成など膨大な工数を自動生成技術により無くし、省人化と時短を実現したことで、お客様は欲しい収納のスケッチをアップロードするだけで、設計プランナーが図面と見積書でご提案致します。このサービスは提案から製造・設置施工まで全国でご対応します。（2024年度までは首都圏のみでご対応）<br>
            自分の欲しいサイズで、引出しや扉、色柄素材も自由にそして低価格で家具を作る事ができれば、きっと皆様に喜んで頂ける。これまでは、家具はたくさんの中から「選ぶもの」だったと思います。<br>
            これからはスケッチを描いて「造るもの」となると思います。<br>
            <br>
            この「スケッチオーダー」によって、これまで不可能だったオーダー家具の汎用化が実現すると思います。私たちのスケッチオーダーによって、皆様の快適な住み心地に貢献できるよう、職人もエンジニアも設計者も力を合わせて全力で邁進いたします。何卒、お力添え頂けますようお願い申し上げます。
          </p>
        </section>
        <!-- <section id="howto">
          <h3>スケッチの描き方(参考)</h3>
          <p class="description">
            インテリア雑誌やInstagramなどで、欲しい家具に近いイメージを探して、その家具を参考にしながら自分なりのアレンジを加えてスケッチしましょう
          </p>
          <div class="frame_by_frame">
            <ul class="img_container">
              <li><img class="img_list" :src="getImage('howto_sketch/howto_1.png')" alt="スケッチの描き方1"></li>
              <li><img class="img_list" :src="getImage('howto_sketch/howto_2.png')" alt="スケッチの描き方2"></li>
              <li><img class="img_list" :src="getImage('howto_sketch/howto_3.png')" alt="スケッチの描き方3"></li>
              <li><img class="img_list" :src="getImage('howto_sketch/howto_4.png')" alt="スケッチの描き方4"></li>
            </ul>
            <a class="btn_prev" href="javascript:void(0); return false;"><img :src="getImage('btn_prev.png')" alt="preview"></a>
            <a class="btn_next" href="javascript:void(0); return false;"><img :src="getImage('btn_next.png')" alt="next"></a>
          </div>
        </section> -->
      </article>
      <article class="overview" ref="refRequestType">
        <section id="selectedRequestType">
          <h3>ご希望のお問合せ方式をご選択ください</h3>
          <div class="order_select">
            <div @click="onRequestType(1)" :class="{selected: requestType===1}">
              <img class="img_list" :src="getImage('common/talk.svg')" alt="">
              <span>打ち合わせ</span>
            </div>
            <div @click="onRequestType(2)" :class="{selected: requestType===2}">
              <img class="img_list" :src="getImage('common/file.svg')" alt="">
              <span>見積もり</span>
            </div>
            <div @click="onRequestType(3)" :class="{selected: requestType===3}">
              <img class="img_list" :src="getImage('common/pallet.svg')" alt="">
              <span>スケッチ<br>オーダー</span>
            </div>
          </div>
        </section>
      </article>
      <article id="sketch_upload" ref="refUpload">
        <!-- スケッチオーダー -->
        <section class="overview" v-if="requestType==3">
          <h2 class="upload_icon">スケッチアップロード</h2>
          <p class="description">
            ①スケッチができたら、スマホで写真を撮りライブラリに保存<br>
            ②【画像を追加】ボタンからライブラリを選択し保存した写真を選ぶ<br>
            ③アップロード<br>
            <br>
            アップロードされたスケッチは直ちに設計プランナーまで届きます。<br>
            担当設計者が決まりプランニングが開始されます。<br>
            <br>
            スケッチやご要望についての確認のため、担当設計者から電話等でお問い合わせさせていいただく場合は、お気軽に何なりとご要望などお伝えください。<br>
            家具の設計が完了しだい、担当設計者からご連絡させていただき、打ち合わせと設置場所の採寸調査となります。<br>
            <br>
          </p>
          <p class="enable_action" @click="onEnableAct">スケッチのアップロード手順はこちら</p>
          <div class="upload_action" v-show="isAction">
            <ul>
              <li>
                <div>1.画像を追加をタップする</div>
                <img class="img_list" :src="getImage('action/phone/sketchupload_sp01.webp')" alt="スケッチアップロード手順1">
              </li>
              <li>
                <div>2.写真ライブラリを選択する</div>
                <img class="img_list" :src="getImage('action/phone/sketchupload_sp02.webp')" alt="スケッチアップロード手順2">
              </li>
              <li>
                <div>3.一覧から写真で撮った図面を選択する</div>
                <img class="img_list" :src="getImage('action/phone/sketchupload_sp03.webp')" alt="スケッチアップロード手順3">
              </li>
              <li>
                <div>4.写真を確認し選択をタップする</div>
                <img class="img_list" :src="getImage('action/phone/sketchupload_sp04.webp')" alt="スケッチアップロード手順4">
              </li>
              <li>
                <div>5.選択したスケッチが追加されます</div>
                <img class="img_list" :src="getImage('action/phone/sketchupload_sp05.webp')" alt="スケッチアップロード手順5">
              </li>
            </ul>
          </div>
        </section>
        <section class="upload_form" ref="refUpload" v-if="requestType==3">
          <h3 class="h3_color">撮影したスケッチ画像をアップロードする</h3>
          <p>アップロードするスケッチ画像を追加してください。</p>
          <ul class="sketch_list">
            <li v-for="(image, index) in inputForm.upImgList" :key="'upimage-' + index"><img :src="image.thumnail"><a class="close_sketch" @click="removeImage(index)"></a></li>
            <li id="add_sketch" @click="onAddSketch" v-show="inputForm.upImgList.length < 10">
              <a href="javascript:void(0);">画像を追加</a>
              <input type="file" ref="newFileRef" @change="onFileChange">
            </li>
          </ul>
          <div v-if="errors.maxImg" class="error_text2">{{errors.maxImg}}</div>
          <p class="notes">
            ※スケッチ(画像)は10枚まで追加できます<br>
            ※対応ファイル形式:jpg、png、gif、heic<br>
            ※動画はアップロードできません
          </p>
          <div class="form_elements">
            <label class="wide">スケッチの補足、ご要望など</label>
            <textarea name="comment" v-model="inputForm.comment" maxlength="500" placeholder="スケッチでは表現できないご要望をお書きください。※最大500文字"></textarea>
          </div>
        </section>
        <section class="upload_form" v-if="requestType==3">
          <h3 class="h3_normal">連絡先等</h3>
          <div class="form_elements elements_required">
            <label>メールアドレス</label>
            <input type="text" name="mail" v-model.trim="inputForm.email" placeholder="sketchorder@domans.co.jp">
            <div v-if="errors.email" class="error_text">{{errors.email}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>氏</label>
            <input type="text" name="name_1" v-model.trim="inputForm.lastName" maxlength="32" placeholder="家具">
            <label>名</label>
            <input type="text" name="name_2" v-model.trim="inputForm.firstName" maxlength="32" placeholder="太郎">
            <div v-if="errors.name" class="error_text">{{errors.name}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>氏（カナ）</label>
            <input type="text" name="name_kana1" v-model.trim="inputForm.lastNameKana" maxlength="32" placeholder="カグ">
            <label>名（カナ）</label>
            <input type="text" name="name_kana2" v-model.trim="inputForm.firstNameKana" maxlength="32" placeholder="タロウ">
            <div v-if="errors.nameKana" class="error_text">{{errors.nameKana}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>お届け先の郵便番号</label>
            <input type="text" name="postal_code" v-model.trim="inputForm.postcd" @keypress="validateNumber" @input="inputForm.postcd=inputRestNumber($event)" @blur="addressCompletion" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="1510053 ※配送料の計算に使用されます。">
            <div v-if="errors.postcd" class="error_text">{{errors.postcd}}</div>
          </div>
          <div class="form_elements">
            <label>住所</label>
            <input type="text" name="address" v-model="inputForm.address">
          </div>
          <div class="form_elements">
            <label>番地/建物名</label>
            <input type="text" name="streetBuilding" v-model="inputForm.streetBuilding">
          </div>
          <div class="form_elements elements_required">
            <label>連絡先電話番号</label>
            <input type="text" name="phone" v-model.trim="inputForm.tel" @keypress="validateNumber" @input="inputForm.tel=inputRestNumber($event)" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="09011112222">
            <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>設置場所について</label>
            <select name="location" v-model.number="inputForm.location">
              <option value="">--選択してください--</option>
              <option value="1">集合住宅(1階)</option>
              <option value="2">集合住宅(２階以上)</option>
              <option value="3">一戸建て住宅(1階)</option>
              <option value="4">一戸建て住宅(２階以上)</option>
              <option value="5">その他</option>
            </select>
            <div v-if="errors.location" class="error_text">{{errors.location}}</div>
            <div class="cb">
              <input id="elevator" type="checkbox" name="elevator" v-model="inputForm.elevetorFlg">エレベーター有り
            </div>
          </div>
        </section>
        <!-- 打ち合わせ -->
        <section id="meeting" class="upload_form" v-if="requestType==1">
          <h3 class="h3_normal">ご希望内容</h3>
          <div class="radio" id="meeting_btn">
            <input type="radio" name="meeting_radio" id="support_pref" value=1 v-model.number="categoryPref" />
            <label for="support_pref">お問合せ希望</label>
            <input type="radio" name="meeting_radio" id="meeting_pref_zoom" checked="" value=2 v-model.number="categoryPref" />
            <label for="meeting_pref_zoom">お打ち合わせ希望(ZOOM)</label>
            <input type="radio" name="meeting_radio" id="meeting_pref_corp" checked="" value=3 v-model.number="categoryPref" />
            <label for="meeting_pref_corp">お打ち合わせ希望（弊社ショールーム）</label>
          </div>
          <div class="form_elements elements_required">
            <label>氏</label>
            <input type="text" name="name_1" v-model.trim="inputForm.lastName" maxlength="32" placeholder="家具">
            <label>名</label>
            <input type="text" name="name_2" v-model.trim="inputForm.firstName" maxlength="32" placeholder="太郎">
            <div v-if="errors.name" class="error_text">{{errors.name}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>氏（カナ）</label>
            <input type="text" name="name_kana1" v-model.trim="inputForm.lastNameKana" maxlength="32" placeholder="カグ">
            <label>名（カナ）</label>
            <input type="text" name="name_kana2" v-model.trim="inputForm.firstNameKana" maxlength="32" placeholder="タロウ">
            <div v-if="errors.nameKana" class="error_text">{{errors.nameKana}}</div>
          </div>
          <div class="form_elements">
            <label class="wide">お問合せ内容</label>
            <textarea name="comment" v-model="inputForm.comment" maxlength="500" placeholder="お問合せ/お打ち合わせの内容を自由に入力してください"></textarea>
          </div>
          <div class="form_elements">
            <label>第一希望日</label>
            <input type="text" name="pref_date_1st" v-model="inputForm.prefData1">
            <label>第二希望日</label>
            <input type="text" name="pref_date_2nd" v-model="inputForm.prefData2">
            <label>第三希望日</label>
            <input type="text" name="pref_date_3rd" v-model="inputForm.prefData3">
          </div>
          <div class="elements_checkbox">
            <div>本サイトをどちらでお知りになりましたか？</div>
            <div class="cb">
              <input type="checkbox" :id="'opt_insta'" v-model="infoSrc.instagram"/>
              <label :for="'opt_insta'">instagram</label>
              <input type="checkbox" :id="'opt_internet'" v-model="infoSrc.internet"/>
              <label :for="'opt_internet'">インターネット検索</label>
              <input type="checkbox" :id="'opt_introduce'" v-model="infoSrc.introduce"/>
              <label :for="'opt_introduce'">ご紹介</label>
              <input type="checkbox" :id="'opt_advert'" v-model="infoSrc.advert"/>
              <label :for="'opt_advert'">広告</label>
              <input type="checkbox" :id="'opt_other'" v-model="infoSrc.other"/>
              <label :for="'opt_other'">その他</label>
            </div>
          </div>
        </section>
        <!-- 見積もり希望 -->
        <section id="estimate" class="upload_form" v-if="requestType==2">
          <h3 class="h3_normal">お客様情報</h3>
          <div class="form_elements elements_required">
            <label>氏</label>
            <input type="text" name="name_1" v-model.trim="inputForm.lastName" maxlength="32" placeholder="家具">
            <label>名</label>
            <input type="text" name="name_2" v-model.trim="inputForm.firstName" maxlength="32" placeholder="太郎">
            <div v-if="errors.name" class="error_text">{{errors.name}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>氏（カナ）</label>
            <input type="text" name="name_1" v-model.trim="inputForm.lastNameKana" maxlength="32" placeholder="カグ">
            <label>名（カナ）</label>
            <input type="text" name="name_2" v-model.trim="inputForm.firstNameKana" maxlength="32" placeholder="タロウ">
            <div v-if="errors.nameKana" class="error_text">{{errors.nameKana}}</div>
          </div>
          <div class="form_elements elements_required">
            <label>お届け先の郵便番号</label>
            <input type="text" name="postal_code" v-model.trim="inputForm.postcd" @keypress="validateNumber" @input="inputForm.postcd=inputRestNumber($event)" @blur="addressCompletion" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="1510053 ※配送料の計算に使用されます。">
            <div v-if="errors.postcd" class="error_text">{{errors.postcd}}</div>
          </div>
          <div class="form_elements">
            <label>現住所</label>
            <input type="text" name="address" v-model="inputForm.address">
          </div>
          <div class="form_elements">
            <label>番地/建物名</label>
            <input type="text" name="streetBuilding" v-model="inputForm.streetBuilding">
          </div>
          <div class="form_elements">
            <label>メールアドレス</label>
            <input type="text" name="email" v-model="inputForm.email">
          </div>
          <div class="form_elements">
            <label>電話番号</label>
            <input type="text" name="tel" v-model="inputForm.tel">
          </div>
        </section>
        <section id="deliveryBudget" class="upload_form" v-if="requestType==2">
          <h3 class="h3_normal">納品先情報・ご予算</h3>
          <div class="form_elements elements_required">
            <label>納品先郵便番号</label>
            <input type="text" name="postal_code" v-model.trim="inputForm.deliPostcd" @keypress="validateNumber" @input="inputForm.deliPostcd=inputRestNumber($event)" @blur="addressCompletion" oninput="if(value.length>7)value=value.slice(0,7)" placeholder="1510053 ※配送料の計算に使用されます。">
            <div v-if="errors.deliPostcd" class="error_text">{{errors.deliPostcd}}</div>
          </div>
          <div class="form_elements">
            <label>納品先住所</label>
            <input type="text" name="address" v-model="inputForm.deliAddress">
          </div>
          <div class="form_elements">
            <label>番地/建物名</label>
            <input type="text" name="streetBuilding" v-model="inputForm.deliStreetBuilding">
          </div>
          <div class="form_elements elements_required">
            <label>設置場所について</label>
            <select name="location" v-model.number="inputForm.location">
              <option value="">--選択してください--</option>
              <option value="1">集合住宅(1階)</option>
              <option value="2">集合住宅(２階以上)</option>
              <option value="3">一戸建て住宅(1階)</option>
              <option value="4">一戸建て住宅(２階以上)</option>
              <option value="5">その他</option>
            </select>
            <div v-if="errors.location" class="error_text">{{errors.location}}</div>
            <div class="cb">
              <input id="elevator" type="checkbox" name="elevator" v-model="inputForm.elevetorFlg">エレベーター有り
            </div>
          </div>
          <div class="form_elements">
            <label>納品希望時期</label>
            <span class="radio">
              <input type="radio" name="delivery_radio" id="delivery_fast" value=1 v-model.number="deliveryPref" />
              <label for="delivery_fast">できるだけ早く</label>
              <input type="radio" name="delivery_radio" id="delivery_decided" checked="" value=2 v-model.number="deliveryPref" />
              <label for="delivery_decided">まだ決めていない</label>
              <input type="radio" name="delivery_radio" id="delivery_appoint" checked="" value=3 v-model.number="deliveryPref" />
              <label for="delivery_appoint">指定したい</label>
            </span>
          </div>
          <div class="form_elements">
            <label>指定したい場合の希望時期</label>
            <input type="text" name="deliveryPrefText" v-model="inputForm.deliveryPrefText">
          </div>
          <div class="form_elements">
            <label>ご予算</label>
            <input type="text" name="deliAddress" v-model="inputForm.deliAddress">
          </div>
        </section>
        <section id="preference" class="upload_form" v-if="requestType==2">
          <h3 class="h3_normal">ご希望内容</h3>
          <div class="form_elements">
            <label>ご検討中の家具</label>
            <input type="text" name="funitureType" v-model="inputForm.funitureType">
          </div>
          <div class="form_elements">
            <label>設置予定のお部屋</label>
            <input type="text" name="room" v-model="inputForm.room">
          </div>
          <div class="form_elements">
            <label>サイズ横幅(W)mm</label>
            <input type="text" name="width" v-model="inputForm.width">
          </div>
          <div class="form_elements">
            <label>サイズ横幅(H)mm</label>
            <input type="text" name="height" v-model="inputForm.height">
          </div>
          <div class="form_elements">
            <label>サイズ横幅(D)mm</label>
            <input type="text" name="depth" v-model="inputForm.depth">
          </div>
          <div class="form_elements">
            <label>ご希望カラー</label>
            <input type="text" name="colorPref" v-model="inputForm.colorPref">
          </div>
          <div class="form_elements">
            <label class="wide">具体的な家具のイメージやご相談事項、その他ご要望はごちらにご記入ください。</label>
            <textarea name="funitureImage" v-model="inputForm.comment" maxlength="500" placeholder="ご要望あれば自由に入力してください"></textarea>
          </div>
          <div class="upload_elements">
            <div>ご希望の家具に近い写真、手描きスケッチ、家具設置場所の写真や平面図をご添付ください。プラン作成の参考にいたします。</div>
            <ul class="sketch_list">
              <li v-for="(image, index) in inputForm.upImgList" :key="'upimage-' + index"><img :src="image.thumnail"><a class="close_sketch" @click="removeImage(index)"></a></li>
              <li id="add_sketch" @click="onAddSketch" v-show="inputForm.upImgList.length < 10">
                <a href="javascript:void(0);">画像を追加</a>
                <input type="file" ref="newFileRef" @change="onFileChange">
              </li>
            </ul>
            <div v-if="errors.maxImg" class="error_text2">{{errors.maxImg}}</div>
            <p class="notes">
              ※スケッチ(画像)は10枚まで追加できます<br>
              ※対応ファイル形式:jpg、png、gif、heic<br>
              ※動画はアップロードできません
            </p>
          </div>
          <div class="elements_checkbox">
            <div>本サイトをどちらでお知りになりましたか？</div>
            <div class="cb">
              <input type="checkbox" :id="'opt_insta'" v-model="infoSrc.instagram"/>
              <label :for="'opt_insta'">instagram</label>
              <input type="checkbox" :id="'opt_internet'" v-model="infoSrc.internet"/>
              <label :for="'opt_internet'">インターネット検索</label>
              <input type="checkbox" :id="'opt_introduce'" v-model="infoSrc.introduce"/>
              <label :for="'opt_introduce'">ご紹介</label>
              <input type="checkbox" :id="'opt_advert'" v-model="infoSrc.advert"/>
              <label :for="'opt_advert'">広告</label>
              <input type="checkbox" :id="'opt_other'" v-model="infoSrc.other"/>
              <label :for="'opt_other'">その他</label>
            </div>
          </div>
        </section>
        <!-- エラーチェック -->
        <div class="form_submit" v-if="requestType!==0">
          <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
          <button type="button" @click="confirm">送信内容を確認する</button>
        </div>
      </article>
    </template>
    <template v-else>
      <div class="content_main">
        <h1>アップロード内容の確認</h1>
        <section class="confirm_sec">
          <h3>スケッチ画像</h3>
          <div class="img_list">
            <ul class="sketch_list">
              <li v-for="(image, index) in inputForm.upImgList" :key="'upimage-' + index"><img :src="image.thumnail"></li>
            </ul>
          </div>
          <h3>コメント</h3>
          <div id="confirm_comment">{{inputForm.comment}}</div>
        </section>
        <section class="confirm_sec" id="upload_confirm">
          <h3>入力内容</h3>
          <ul>
            <li>
              <div>メールアドレス:</div>
              <div>{{inputForm.email}}</div>
            </li>
            <li>
              <div>氏名:</div>
              <div>{{inputForm.lastName}} {{inputForm.firstName}}</div>
            </li>
            <li>
              <div>氏名（カナ）:</div>
              <div>{{inputForm.lastNameKana}} {{inputForm.firstNameKana}}</div>
            </li>
            <li>
              <div>お届け先の郵便番号:</div>
              <div>{{inputForm.postcd}}</div>
            </li>
            <li>
              <div>連絡先電話番号:</div>
              <div>{{inputForm.tel}}</div>
            </li>
            <li>
              <div>設置場所について:</div>
              <div>{{locationLabel}}</div>
            </li>
            <li>
              <div>エレベーター有り:</div>
              <div>{{isElevetorFlg}}</div>
            </li>
          </ul>
        </section>
        <section class="scroll_rule">
          <dd-userule></dd-userule>
        </section>
        <div class="form_submit">
          <div class="cb">
            <input type="checkbox" name="consent" v-model="isPricyConsent">プライバシーポリシーと利用規約に同意する
          </div>
          <div class="action_area">
            <button type="button" @click="cancel">戻る</button>
            <button type="button" @click="complete" :class="{disabled : !isUploadEnable}">アップロード</button>
          </div>
        </div>
      </div>
    </template>
    <div class="bottom_nav">
      <div @click="onRequestTypeAndJump(1)" :class="{selected: requestType===1}">
        <img class="img_list" :src="getImage('common/talk.svg')" alt="">
        <span>打ち合わせ</span>
      </div>
      <div @click="onRequestTypeAndJump(2)" :class="{selected: requestType===2}">
        <img class="img_list" :src="getImage('common/file.svg')" alt="">
        <span>見積もり</span>
      </div>
      <div @click="onRequestTypeAndJump(3)" :class="{selected: requestType===3}">
        <img class="img_list" :src="getImage('common/pallet.svg')" alt="">
        <span>スケッチ<br>オーダー</span>
      </div>
    </div>
    <dd-footer></dd-footer>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../utils/App'
import * as Api from '../utils/Api'
import * as Check from '../utils/Check'
import * as FormUtil from '../utils/FormUtil'
import BannerSwiper from '../components/common/BannerSwiper'
import {DC_URL, DC_STORAGE_KEY} from '../constants/App'
import LoadingModal from '../components/common/LoadingModal'
import UseRuleDetail from '../components/common/UseRuleDetail.vue'
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  name: 'Top',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-userule': UseRuleDetail,
    'dd-loading-modal': LoadingModal,
    'dd-banner': BannerSwiper
  },
  data () {
    return {
      inputForm: {
        upImgList: [],
        comment: '',
        mail: '',
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        postcd: '',
        address: '',
        streetBuilding: '',
        tel: '',
        location: '',
        elevetorFlg: false
      },
      categoryOptions: {
        slidesPerView: 'auto',
        slidesPrGroup: 2,
        slidesPerColumn: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        SimulateTouch: true,
        touchStartPreventDefault: false,
        preventClicks: true,
        centeredSlides: false,
        spaceBetween: 10,
        initialSlide: 0,
        // loop: true,
        autoPlay: {
          delay: 3000,
          pauseOnMouseEnter: true
        }
      },
      bannerList: [
        {id: 1, img: 'about_sketch_order/about_1.png', alt: 'スケッチオーダーとは1'},
        {id: 2, img: 'about_sketch_order/about_2.png', alt: 'スケッチオーダーとは2'},
        {id: 3, img: 'about_sketch_order/about_3.png', alt: 'スケッチオーダーとは3'}
      ],
      isMobile: false,
      errors: [],
      userInfo: undefined,
      isAction: false,
      isConfirm: false,
      // confirm
      locationList: [
        {id: 1, label: '集合住宅(1階)'},
        {id: 2, label: '集合住宅(２階以上)'},
        {id: 3, label: '一戸建て住宅(1階)'},
        {id: 4, label: '一戸建て住宅(２階以上)'},
        {id: 5, label: 'その他'}
      ],
      infoSrc: {
        instagram: '',
        internet: '',
        introduce: '',
        advert: '',
        other: ''
      },
      requestType: 0,
      isPricyConsent: false,
      topHeight: 0
    }
  },
  computed: {
    // confirm
    isElevetorFlg: function () {
      if (this.inputForm.elevetorFlg) return 'あり'
      return 'なし'
    },
    locationLabel: function () {
      let location = this.locationList.filter(l => l.id === this.inputForm.location)
      return location ? location[0].label : ''
    },
    isUploadEnable: function () {
      if (this.isPricyConsent) {
        return true
      }
      return false
    }
  },
  methods: {
    getImage: function (image) {
      return App.getSketchResource(image)
    },
    onEnableAct: function (e) {
      this.isAction = !this.isAction
    },
    onFileChange: function (e) {
      const files = e.target.files || e.dataTransfer.files
      if (files[0].name.indexOf('.heic') > -1 || files[0].name.indexOf('.HEIC') > -1) {
        this.$refs.loadingModalRef.showModal(true)
        FormUtil.convertHeicToJpeg(files[0], (callback) => {
          this.createImage(callback)
          this.$refs.loadingModalRef.showModal(false)
        })
      } else {
        this.$refs.loadingModalRef.showModal(true)
        this.createImage(files[0])
        this.$refs.loadingModalRef.showModal(false)
      }
    },
    onAddSketch: function (e) {
      this.$refs.newFileRef.click()
    },
    createImage: function (file) {
      // var image = new Image()
      if (this.inputForm.upImgList.length >= 10) {
        this.errors['maxImg'] = '画像は10枚まで添付できます。'
        return
      }
      var reader = new FileReader()
      var vm = this
      var obj = {}
      reader.onload = function (e) {
        obj.thumnail = e.target.result
        obj.uploadFile = file
        obj.name = file.name
        vm.inputForm.upImgList.push(obj)
        // console.log('json--------------')
        // console.log(JSON.stringify(obj))
        // console.log('dir--------------')
        // console.dir(obj)
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (index) {
      // console.log('remove index:' + index)
      this.inputForm.upImgList = this.inputForm.upImgList.filter((n, idx) => idx !== index)
    },
    validateRequire: function () {
      if (this.inputForm.upImgList.length <= 0) this.errors['maxImg'] = '画像は１枚以上添付してください。'
      if (!this.inputForm.email) this.errors['email'] = 'メールアドレスは必須項目です。'
      if (!this.inputForm.lastName || !this.inputForm.firstName) this.errors['name'] = '氏名は必須項目です。'
      if (!this.inputForm.lastNameKana || !this.inputForm.firstNameKana) this.errors['nameKana'] = '氏名（カナ）は必須項目です。'
      if (!this.inputForm.tel) this.errors['tel'] = '連絡先電話番号は必須項目です。'
      if (!this.inputForm.postcd) this.errors['postcd'] = 'お届け先の郵便番号は必須項目です。'
      if (this.inputForm.postcd && !this.inputForm.address) this.errors['postcd'] = '存在しない郵便番号です。'
      if (!this.inputForm.location) this.errors['location'] = '設置場所については必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isPostCd(this.inputForm.postcd)) this.errors['postcd'] = 'お届け先の郵便番号は半角数値で入力してください。'
      if (!Check.isTel(this.inputForm.tel)) this.errors['tel'] = '連絡先電話番号は半角数値かつ、10～11文字で入力してください。'
      if (!Check.isKana(this.inputForm.lastNameKana) || !Check.isKana(this.inputForm.firstNameKana)) this.errors['nameKana'] = '氏名（カナ）はカタカナで入力してください。'
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    guestLogin: async function () {
      this.$refs.loadingModalRef.showModal(true)
      await axios.get(DC_URL.LOGIN + '/guest-sketchorder')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.userInfo = response.data.data
            console.log('set guest user:' + Object.entries(this.userInfo))
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, this.userInfo)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    confirm: async function () {
      await this.guestLogin()
      await this.confirmAfter()
    },
    confirmAfter: async function () {
      // 入力チェック
      this.errors = {}
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.$refs.loadingModalRef.showModal(true)
      let payload = new FormData()
      for (let i = 0; i < this.inputForm.upImgList.length; i++) {
        payload.append('upImgList[' + i + ']', new Blob([this.inputForm.upImgList[i].uploadFile], {type: 'image/jpeg'}), this.inputForm.upImgList[i].name)
      }
      payload.append('comment', this.inputForm.comment)
      payload.append('email', this.inputForm.email)
      payload.append('lastName', this.inputForm.lastName)
      payload.append('firstName', this.inputForm.firstName)
      payload.append('lastNameKana', this.inputForm.lastNameKana)
      payload.append('firstNameKana', this.inputForm.firstNameKana)
      payload.append('tel', this.inputForm.tel)
      payload.append('postcd', this.inputForm.postcd)
      payload.append('address', this.inputForm.address)
      payload.append('streetBuilding', this.inputForm.streetBuilding)
      payload.append('location', this.inputForm.location)
      payload.append('elevetorFlg', this.inputForm.elevetorFlg)
      payload.append('form', this.inputForm)
      axios.post(DC_URL.SKETCH + '/upload', payload
      ).then(response => {
        this.topHeight = this.$refs.refUpload.offsetTop + this.$refs.refUpload.offsetHeight
        scrollTo(0, 0)
        this.isConfirm = true
        this.$refs.loadingModalRef.showModal(false)
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    // confirm
    cancel: function () {
      this.isConfirm = false
      scrollTo(0, 0)
    },
    complete: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.post(DC_URL.SKETCH + '/confirm', {}
      ).then(response => {
        this.$router.push({
          name: 'UploadComplete'
        })
        this.$refs.loadingModalRef.showModal(false)
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    onSketchUpload: function () {
      const el = this.$refs['refUpload']
      el.scrollIntoView({behavior: 'smooth'})
    },
    onRequestType: function (val) {
      if (this.requestType === val) {
        this.requestType = 0
      } else {
        this.requestType = val
      }
    },
    onRequestTypeAndJump: function (val) {
      this.onRequestType(val)
      const el = this.$refs['refRequestType']
      el.scrollIntoView({behavior: 'smooth'})
    },
    addressCompletion: function () {
      FormUtil.addressCompletion(this.inputForm.postcd, (address) => {
        this.$set(this.inputForm, 'address', address.state + address.city + address.street)
      })
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/top.scss" lang="scss" scoped></style>
<style src="../css/main.scss" lang="scss" scoped></style>
<style src="../css/upload.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/Top.vue